export default (): boolean => {
    /** @ts-ignore */
    const manyTouchPoints = navigator.msMaxTouchPoints > 0
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || manyTouchPoints
}
